/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignStatusChange } from '../../axios/campaignStatusChange'
import type {
	CampaignStatusChangeError,
	CampaignStatusChangePathParams,
	CampaignStatusChangeRequest,
	CampaignStatusChangeResponse,
} from '../../types/CampaignStatusChange'

export const campaignStatusChangeMutationKey = () => [{ url: '/campaigns/:campaign/status' }] as const

export type CampaignStatusChangeMutationKey = ReturnType<typeof campaignStatusChangeMutationKey>

export type CampaignStatusChangeVariables = {
	campaign: CampaignStatusChangePathParams['campaign']
	data: CampaignStatusChangeRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignStatusController.php CampaignStatusController::change */
export function useCampaignStatusChange<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignStatusChangeResponse,
		AxiosError<CampaignStatusChangeError>,
		CampaignStatusChangeVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignStatusChangeMutationKey(),
		mutationFn: ({ campaign, data }: CampaignStatusChangeVariables) =>
			campaignStatusChange(campaign, data, config).then(res => res.data),
		...options,
	})
}
